import AppState from 'js/stores/AppState';
/**
 * Parent class used to abstract the various login/auth/registration services (FacebookAuth, PayOnDeliverAuth, etc)
 *
 * @class UserAuthenticationService
 */
export default class UserAuthenticationService {
  login() {}
  logout() {}
  processLoginResponse(response) {
    if ( !response.is_registered && true === response.confirmation ) {
      AppState.setShowConfirmationCode(true);
      AppState.setMSeller(response.mseller);
    }

    return response;
  }
  processLogoutResponse(response) {
    return response;
  }
}
